import React from 'react';
import './LayersLoadingIndicator.css';
import { getTranslation } from '../../utils/translations';
import { useLanguage } from '../../App';

const LayersLoadingIndicator = ({ isVisible, message }) => {
  const { language } = useLanguage();

  if (!isVisible) return null;

  return (
    <div className="layers-loading-indicator">
      <div className="layers-loading-content">
        <div className="layers-loading-spinner">
          {/* <img src="/logo_only.png" alt="Loading" className="loading-logo" /> */}
        </div>
        <div className="layers-loading-text">
          {message || getTranslation("loadingLayers", language)}
        </div>
      </div>
    </div>
  );
};

export default LayersLoadingIndicator;
